import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";

export function LockedPanel({ unlockAt, onRetry }: { unlockAt: string; onRetry: () => void }) {
  const target = new Date(unlockAt).getTime();
  // Lazy initializer keeps the clock read out of render (purity).
  const [remaining, setRemaining] = useState(() => Math.max(0, target - Date.now()));

  useEffect(() => {
    const id = setInterval(() => {
      const r = Math.max(0, target - Date.now());
      setRemaining(r);
      if (r === 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  const minutes = Math.floor(remaining / 60_000);
  const seconds = Math.floor((remaining % 60_000) / 1000);

  return (
    <div className="space-y-4" aria-live="polite">
      <div>
        <h2 className="font-serif text-xl text-maroon-700">Locked</h2>
        <p className="text-sm text-ink-500">
          Too many attempts. Try again in {minutes}:{seconds.toString().padStart(2, "0")}.
        </p>
      </div>
      {remaining === 0 && (
        <Button onClick={onRetry} className="w-full">Back to sign in</Button>
      )}
    </div>
  );
}
